"use client"

import SplitTextAnimation from "components/SplitText"
import team1 from "images/home/statement/Team1.png"
import team2 from "images/home/statement/Team2.png"
import team3 from "images/home/statement/Team3.png"
import team4 from "images/home/statement/Team4.png"
import StaticImage from "library/StaticImage"
import { css, fmobile, fresponsive, ftablet, styled } from "library/styled"
import { useMedia } from "library/useMedia"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function Statement() {
	const alteredPreposition = useMedia(
		"without",
		"without",
		"with- out",
		"without",
	)

	return (
		<Wrapper>
			<Title>
				<Spacer />
				Arlo is a self<span>-</span>funded health plan for small
				<ImageWrapper>
					<InlineImage src={team1} alt={"team member"} width={48} height={48} />
				</ImageWrapper>
				and medium-sized
				<TeamImagesSpan>
					<InlineImage
						className="team-images"
						src={team2}
						alt={"team member"}
						width={48}
						height={48}
					/>
					<InlineImage
						className="team-images"
						src={team3}
						alt={"team member"}
						width={48}
						height={48}
					/>
					<InlineImage
						className="team-images"
						src={team4}
						alt={"team member"}
						width={48}
						height={48}
					/>
				</TeamImagesSpan>
				businesses seeking to provide exceptional healthcare coverage{" "}
				{alteredPreposition} the traditional price tag.
			</Title>
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...fresponsive(css`
		position: relative;
		display: grid;
		place-items: center;
		height: 556px;
		width: 100%;
		margin: 0 auto;
	`),

	...ftablet(css`
		height: 972px;
	`),

	...fmobile(css`
		height: 100lvh;
		display: grid;
		place-items: center;
		place-content: center;
	`),
})

const Title = styled(SplitTextAnimation, {
	...fresponsive(css`
		${textStyles.h5};
		color: ${colors.js.green100};
		text-align: left;
		width: 996px;
		margin-left: auto;
		margin-right: auto;
		display: block;
		white-space: normal;
	`),
	...ftablet(css`
		width: 765px;
	`),
	...fmobile(css`
		text-align: center;
		${textStyles.h6};
		width: 327px;
		hyphens: manual;
		overflow-wrap: break-word;
	`),
})

const TeamImagesSpan = styled("span", {
	...fresponsive(css`
		position: relative;
		display: inline-block;
		vertical-align: middle;
		width: auto;
		margin: 0 8px;
		transform: translateY(-6px);
	`),

	...ftablet(css`
		margin: 0 8px 0 0;
	`),
	...fmobile(css`
		margin: 0 8px;
	`),
})

const InlineImage = styled(StaticImage, {
	...fresponsive(css`
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: inline-block;
		vertical-align: middle;

		&:nth-of-type(1) {
			z-index: 2;
		}

		&:nth-of-type(2) {
			margin-left: -10px;
			z-index: 1;
		}

		&:nth-of-type(3) {
			margin-left: -10px;
			z-index: 0;
		}
	`),
	...ftablet(css`
		width: 45px;
		height: 45px;

		${TeamImagesSpan} & {
			&:nth-of-type(1) {
				z-index: 2;
			}

			&:nth-of-type(2) {
				margin-left: -8px;
				z-index: 1;
			}

			&:nth-of-type(3) {
				margin-left: -8px;
				z-index: 0;
			}
		}
	`),

	...fmobile(css`
		width: 36px;
		height: 36px;

		${TeamImagesSpan} & {
			&:nth-of-type(2) {
				margin-left: -6px;
				z-index: 1;
			}

			&:nth-of-type(3) {
				margin-left: -6px;
				z-index: 0;
			}
		}
	`),
})

const Spacer = styled("span", {
	...fresponsive(css`
		display: inline-block;
		width: 260px;
	`),

	...ftablet(css`
		display: inline-block;
		width: 70px;
	`),

	...fmobile(css`
		display: none;
	`),
})

const ImageWrapper = styled("span", {
	...fresponsive(css`
		display: inline-block;
		width: 48px;
		height: 48px;
		border-radius: 50%;
		margin: 0 10px;
	`),
	...ftablet(css`
		width: 45px;
		height: 45px;
	`),
	...fmobile(css`
		width: 36px;
		height: 36px;
		margin: 0 8px;
	`),
})
